import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import siteReducer from './reducers/siteReducer';

const rootReducer = combineReducers({
	sites: siteReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;